import { useDiscountRemovalPopup } from '@/hooks';
import { Button, Dialog, Stack, Typography } from '@prenuvo/halo-web';

const DiscountRemovalPopup = () => {
  const {
    showDiscountRemovalPopup,
    discountIsAvailable,
    discountIsValid,
    handleProceedWithoutDiscount,
    handleSelectDifferentDate,
  } = useDiscountRemovalPopup();

  if (!discountIsAvailable) return null;

  return (
    <Dialog
      footer={
        <Stack gap={4} justification="end">
          <Button
            onClick={handleProceedWithoutDiscount}
            variant="text"
            data-testid="proceed-without-discount"
          >
            Proceed without discount
          </Button>
          <Button
            onClick={handleSelectDifferentDate}
            variant="primary"
            data-testid="select-different-date"
          >
            Select different date
          </Button>
        </Stack>
      }
      // What we want to happen if the user clicks outside the dialog to close it
      onOpenChange={handleSelectDifferentDate}
      open={showDiscountRemovalPopup && discountIsValid}
      title={{
        children: 'This is not a valid booking date.',
      }}
    >
      <Typography data-testid="discount-not-valid">
        This discount code is not valid for the date chosen. To use this discount, please select a
        different booking date.
      </Typography>
    </Dialog>
  );
};

export default DiscountRemovalPopup;
